// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2B5Urk","message":"_21DFfu"};